var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visivel)?_c('div',{staticClass:"env-banner"},[_vm._v("AMBIENTE DE TESTES")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }